module.exports = vendors_tr_172c96e076eacdd2a724;